<template>
  <Frontendlayout>
    <section class="hero_in general">
			<div class="wrapper">
				<div class="container">
					<h1 class="fadeInUp"><span></span>Requirements</h1>
				</div>
			</div>
		</section>

<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
		<Signin/>
    </div>
  </div>
</div> 
        <div class="bg_color_1">
			<nav class="secondary_nav sticky_horizontal">
				<div class="container">
					<ul class="clearfix">
						<li><a href="#description" :class="$route.params.slug!='#reviews'?'active':''">Description</a></li>
						<li><a href="#reviews" :class="$route.params.slug=='#reviews'?'active':''">Reviews</a></li>
						<li><a href="#sidebar">Booking</a></li>
					</ul>
				</div>
			</nav>
			<div class="container margin_60_35">
				<div class="row">
					<div class="col-lg-8">
						<section id="description">
							<h2 v-html="list.event"></h2>
							<h4 v-html="list.description"></h4>
					<hr>
							<h3>Description</h3>
							<p>	{{list.short_description}}</p>					
							<hr>
							<p><strong>Category:</strong></p>
							<div class="row">
								<div class="col-lg-6" v-for="category in list.categories" :key="category.id">
									<ul class="bullets">
										<li>{{category.category}}</li>
									</ul>
								</div>
							</div>
							<hr>
					</section>
						<section id="reviews" v-if="offer.length>0">
							<h3>Merchant Offers</h3>
							<p>
							</p>
							<div v-for="(offers, index) in offer" :key="index">
							<ul class="cbp_tmtimeline">
								<li>
									<time class="cbp_tmtime" datetime="14:30"><span>{{new Date(offers.timestamp).toDateString()}}</span><span>{{new Date(offers.timestamp).toLocaleTimeString('pt-BR')}}</span>
									</time>
									<div class="cbp_tmicon">
										{{index+1}}
									</div>
									<div class="cbp_tmlabel">
										<div class="hidden-xs">
											<router-link :to="`/merchant/profile/${offers.user_id}`" ><img :src="tour_plan_1" alt="" class="rounded-circle thumb_visit"></router-link>
										</div>
										<h4>Offer Price<small>(&#8377; {{offers.offer_price}})</small></h4>
										<p>
											{{offers.offer_summary}}
										</p>
									</div>
								</li>
							</ul>
							</div>
							<hr>
						</section>
					</div>
					<aside class="col-lg-4" id="sidebar">
						<div class="box_detail booking">
							<div class="price">
								<span>{{list.location}} </span>
								<div class="score "><strong>{{list.pincode}}</strong></div>
							</div>
							<form @submit.prevent="openLoginModal()">
							<div class="form-group input-dates">
								<label for="when">Event Stat Date</label>
								<input class="form-control" type="date" disabled :value="list.event_date" placeholder="When..">
							</div>
							<div class="form-group">
								<label for="Offer">Offer Price</label>
								<input class="form-control" v-model="offerPrice" type="number" required placeholder="Offer amount"/>
							</div>
								<div class="form-group">
								<label for="Offer Summary">Offer Summary</label>
								<textarea class="form-control" v-model="offerSummary" required rows="4" cols="50"></textarea>							
								</div>
							<div class="col-md-12 row" >
							<div class="form-group col-md-5">
								<label><input style="height: 12px;" type="checkbox" v-model="check1" checked disabled /> Website </label>
							</div>
							
							<div class="form-group col-md-3" style="padding:0px;">
								<label><input style="height: 12px;" type="checkbox" v-model="check2" value="sms" /> SMS  </label>
							</div>
							
							<div class="form-group col-md-4">
								<label><input style="height: 12px;" type="checkbox" v-model="check3" value="email" /> Email </label>
							</div></div>
							<button class="btn_1 full-width purchase">Send Offer</button>
							<!--<a href="wishlist.html" class="btn_1 full-width outline wishlist"><i class="icon_heart"></i> Add to wishlist</a>-->
							</form>
						</div>
					
						<!--<ul class="share-buttons">
							<li><a class="fb-share" href="#0"><i class="social_facebook"></i> Share</a></li>
							<li><a class="twitter-share" href="#0"><i class="social_twitter"></i> Tweet</a></li>
							<li><a class="gplus-share" href="#0"><i class="social_googleplus"></i> Share</a></li>
						</ul>-->
					</aside>
				</div>
			</div>
			</div>

		
  </Frontendlayout>
</template>

<script>
  /* eslint-disable */
import Frontendlayout from "../layouts/Frontendlayout.vue";
import API from "@/services/index";
import $ from 'jquery';
import Signin from "../components/Signin";
export default {
  data() {
    return {
      name: "Home",
      divId: "home",
      bodyId: "",
	  check1:'web',
		check2:'',
		check3:'',
		pointmsg:'',
	  list: {},
	  offer: [],
	  offerPrice: null,
	  offerSummary: '',
	  tour_plan_1: require("@/assets/view.png"),
	  requirement_smsprice:'',
	  requirement_emailprice:'',
	  requirement_notiprice:'',
	  	
    };
  },
  components: { Frontendlayout, Signin},
  mounted() {
this.getList()
this.checkpoint();
  },
   methods: {
	   openLoginModal: function () {
		const token = localStorage.getItem("token");
        const roleId = localStorage.getItem("role_id");
var vthis = ''

      if (token != null) {
        if ( roleId == 2) { 

		const form = new FormData();

      form.append("website", this.check1)
      form.append("email", this.check3)
      form.append("sms", this.check2)

      API.post(`Sendrequirement/getrequirementprice`,form, {
        headers: { Authorization: "Bearer "+token },
      })
        .then((res) => {
      
		this.$swal({
        title: 'Are you sure!',
        text: res.data,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes Proceed to Offer",
        closeOnConfirm: false,
      }).then((isConfirm) => {
  

        if (!isConfirm.isConfirmed) {
        //   Toast.fire({
        //     icon: "error",
        //     title: "Bid Failed. Please try again",
        //   });
		// this.check1 = '';
		// this.check2 = '';
		// this.check3 = '';
          this.$router.push(`/user-post-single/`+this.$route.params.id);
          return false;
        }else {

				const form = new FormData();
				form.append("website", this.check1)
				form.append("email", this.check3)
				form.append("sms", this.check2)
				form.append("offerprice", this.offerPrice)
				form.append("offersummary", this.offerSummary)

					API.post(`Sendrequirement/send_requirement/${this.$route.params.id}`,form, {
					headers: { Authorization: "Bearer "+token },
				})
					.then((res) => {
						
					if (res.data.status == 200) {
						this.$swal("success	", res.data.messages);  
						this.$router.push({ name: 'UserPost' })
					} else {

					this.$swal(res.data.messages);

					}
					})
					.catch((err) => {
					console.log(err.response);
					});
        }
      });
	
        })



      
		
        } else {
		this.$swal("Error", "Only For Merchant");
        }
      }else{
		  window.$('.bd-example-modal-lg').modal('show')
	  }
		},

		checkpoint(){
			
			const token = "Bearer " + localStorage.getItem("token");
				API.get('Postrequirement/requirement_points', {
				headers: { Authorization: token },
			})
			.then((res) => {

				res.data.forEach((value) => {
					console.log(value.meta_kay);
					if(value.meta_kay == 'requirement_smsprice'){
					this.requirement_smsprice = value.meta_value;
					}
					if(value.meta_kay == 'requirement_emailprice'){
						this.requirement_emailprice = value.meta_value;
					}
					if(value.meta_kay == 'requirement_notiprice'){
						this.requirement_notiprice = value.meta_value;
					}

				})
				
				
			
			})
			.catch((err) => {
			console.log(err.response);
			});

		},
	  getList(){
		const token = "Bearer " + localStorage.getItem("token");
		 API.get(`Postrequirement/singleList/${this.$route.params.id}`, {
        headers: { Authorization: token },
      })
        .then((res) => {
			res.data.data.forEach((value) => {
 			this.list=value
			})
         
        })
        .catch((err) => {
          console.log(err.response);
        });
		if(localStorage.getItem("token")!=null){
				API.get(`Sendrequirement/getOffer/${this.$route.params.id}`, {
        headers: { Authorization: token },
      })
        .then((res) => {
				this.offer=res.data.data

        })
        .catch((err) => {
          console.log(err.response);
        });
		}
	
	  }
	  
  },
};
</script>
